function CircleCheckmarkIcon() {
  return (
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
      focusable={false}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 0C5.37258 0 0 5.37258 0 12V44C0 50.6274 5.37258 56 12 56H44C50.6274 56 56 50.6274 56 44V12C56 5.37258 50.6274 0 44 0H12ZM13.0062 28.013C13.0062 36.2973 19.722 43.013 28.0062 43.013C36.2905 43.013 43.0062 36.2973 43.0062 28.013C43.0062 19.7288 36.2905 13.013 28.0062 13.013C19.722 13.013 13.0062 19.7288 13.0062 28.013ZM34.6124 20.8857C35.0983 20.3947 35.8902 20.3905 36.3812 20.8764C36.8159 21.3334 36.861 22.036 36.4884 22.5448L27.9923 34.7101C27.8658 34.891 27.7086 35.0483 27.5277 35.1748C26.6749 35.7708 25.5005 35.5628 24.9044 34.7101L20.7641 28.782C20.3912 28.2731 20.4363 27.5703 20.8711 27.1132C20.9219 27.063 20.9768 27.0172 21.0354 26.9764C21.6019 26.5812 22.3816 26.7202 22.7768 27.2868L26.4482 32.5438L34.4756 21.05C34.5165 20.9914 34.5622 20.9365 34.6124 20.8857Z"
      />
    </svg>
  );
}

export default CircleCheckmarkIcon;
